import APIService from '../api.service';

export const All = (params) => {
    return APIService.get(`/v01/stock-requests`, {
        params: {
            per_page: params.perPage,
            page: params.page,
            keyword: params.keyword,
            status: params.status,
            from_date: params.fromDate,
            to_date: params.toDate,
            from_warehouse_id: params.from_warehouse_id,
            to_warehouse_id: params.to_warehouse_id,
        },
    });
};

export const Create = (body, config) => {
    return APIService.post(`/v01/stock-requests`, body, config);
};

export const Get = (id) => {
    return APIService.get(`/v01/stock-requests/${id}`);
};

export const Update = (id, body, config) => {
    return APIService.put(`/v01/stock-requests/${id}`, body, config);
};

export const Delete = (id) => {
    return APIService.delete(`/v01/stock-requests/${id}`);
};

export const Submit = (id) => {
    return APIService.post(`/v01/stock-requests/${id}/submit`);
};

export const Cancel = (id) => {
    return APIService.post(`/v01/stock-requests/${id}/cancel`);
};

export const WarehouseOptions = () => {
    return APIService.get(`/v01/stock-requests/warehouse-options`);
};

const StockRequestService = {
    All,
    Create,
    Get,
    Update,
    Delete,
    Submit,
    Cancel,
    WarehouseOptions,
};

export default StockRequestService;
